import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import { ISeoTranslation } from './useGetSeoPageInfo';

export interface ISeoPageInfoRequest {
  url_shortcut: ISeoTranslation[];
  page_type: string;
  params: string;
  entity_id: number;
  entity_type: string;
  h1: ISeoTranslation[];
  meta_title: ISeoTranslation[];
  meta_description: ISeoTranslation[];
  meta_keywords: ISeoTranslation[];
  open_graph_title: ISeoTranslation[];
  open_graph_description: ISeoTranslation[];
}

const putSeoPageInfo = (id: number, data: ISeoPageInfoRequest): Promise<ICommandResponseSuccess> =>
  axios.put(`/panel/seo-page-info/${id}`, data);

export const usePutSeoPageInfo = (
  id: number,
  options?: UseMutationOptions<ICommandResponseSuccess, IError, ISeoPageInfoRequest>
) =>
  useMutation((data: ISeoPageInfoRequest) => putSeoPageInfo(id, data), options);
